import axios from 'axios';
import { SERVICE_URL, SERVICE_URL_V2 } from '../utils/constants';
let controller = new AbortController();

export type postDataType = {
  dialog_id: string;
  idle_sync_url: string;
  voice: string;
  bot_id: string;
  bot_alias_id: string;
  locale_id: string;
  session_id: string;
  session_attributes: string;
  talking_head: boolean;
  lipsync_version?: number;
  isMobile: boolean;
};

export const authenticate = async (dialogId: string) => {
  const response = await axios.get(
    SERVICE_URL + '/authenticate?dialog_id=' + dialogId
  );
  return response.data;
};

const objToFormData = (obj: any) => {
  const formData = new FormData();
  for (let key in obj) {
    formData.append(key, obj[key]);
  }
  return formData;
};

const processPostData = (
  postData: postDataType,
  userInput: string,
  type: string
) => {
  console.log('🚀 ~ userInput:', userInput);
  const { session_attributes } = postData;
  const data = {
    ...postData,
    user_text: type === 'text' ? userInput : '',
    audio_file: type === 'voice' ? userInput : '',
    session_attributes:
      session_attributes && session_attributes.trim()
        ? JSON.stringify(session_attributes)
        : '',
  };
  return data;
};

export const fetchBotResponse = async (
  postData: postDataType,
  token: string,
  userInput: string,
  type: string,
  apiVersion: string
) => {
  controller = new AbortController();
  const headers = {
    accept: 'application/json',
    'Content-Type': 'multipart/form-data',
    Authorization: 'Bearer ' + token,
  };
  const formdata = objToFormData(processPostData(postData, userInput, type));
  let postUrl = SERVICE_URL + '/ai/bot_response';
  if (apiVersion === '2') {
    postUrl = SERVICE_URL_V2 + '/ai/llm_qa';
  }

  const response = await axios.post(postUrl, formdata, {
    headers: headers,
    signal: controller.signal,
  });
  return response.data;
};

export const abortFetchResponse = () => {
  controller.abort();
};

const getHeaders = (token: string) => {
  return {
    accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: 'Bearer ' + token,
  };
};

export const sendFeedback = async (
  token: string,
  call_id: string,
  feedback: string
) => {
  const headers = getHeaders(token);
  await axios.post(
    SERVICE_URL +
      '/ai/user_feedback?call_id=' +
      call_id +
      '&feedback=' +
      feedback,
    {},
    { headers: headers }
  );
};

export const uploadFile = async (url: string, formData: FormData) => {
  const headers = {
    'Content-Type': 'multipart/form-data;',
  };
  const response = await axios.post(url, formData, {
    headers: headers,
  });
  return response.data;
};
